// extracted by mini-css-extract-plugin
module.exports =  {"notification":"kSs3on","icon":"Hbj9ba","link":"rpf1vz"};